import { createPinia } from 'pinia';
import { createPersistedStatePlugin } from 'pinia-plugin-persistedstate-2';
import LocalForage from 'localforage';

export function initializePinia() {
  const pinia = createPinia();

  const localForage = LocalForage.createInstance({
    name: 'sellia-workspace',
    storeName: 'sellia-workspace',
    driver: LocalForage.INDEXEDDB,
  });

  pinia.use(
    createPersistedStatePlugin({
      persist: false,
      storage: {
        getItem: async (key) => {
          return localForage.getItem(key);
        },
        setItem: async (key, value) => {
          return localForage.setItem(key, value);
        },
        removeItem: async (key) => {
          return localForage.removeItem(key);
        },
      },
    }),
  );

  return pinia;
}
